import I18N from "oc-I18N";
import dialogs from "./dialogs/Dialogs.js";
import SafePromise from "oc-commons/SafePromise.js";

export function exception(name,message,modal=true) {
    const error = new Error(message);
    error.info = {
        name: name,
        message: message,
        modal: modal,
    };
    return error;
}

export function formatAjaxError(err) {
    if (err==null) {
        return null;
    }
    if (err.responseJSON) {
        return '(' + err.status + ') ' + err.responseJSON?.error?.message;
    }
    let message = '';
    if (err.status!=null) {
        message += '(' + err.status + ') ';
    }
    if (err.message!=null) {
        message += err.message+' ';
    }
    if (err.responseText!=null) {
        message += err.responseText;
    }
    return message.substringBefore('Stacktrace:');
}

function removeStacktrace(message) {
    if (message) {
        message = message.substringBefore('Stacktrace:');
    }
    return message;
}

export function serverCommunicationError(err) {
    console.log('serverCommunicationError',err);
    showError(removeStacktrace(formatAjaxError(err)));
};

export function serverCommunicationWarning(err) {
    console.log('serverCommunicationError',err);
    showWarning(removeStacktrace(formatAjaxError(err)));
};

window.USE_SAFE_PROMISE = window.USE_SAFE_PROMISE===undefined ? true : window.USE_SAFE_PROMISE;

/**
 * @export
 * @returns {SafePromise}
 */
export function defaultCatchAsError(promise) {
    if (window.USE_SAFE_PROMISE) {
        return new SafePromise(promise).defaultCatch(serverCommunicationError);
    } else {
        _.delay(()=>promise.catch(serverCommunicationError),300);
        return promise;
    }
}

/**
 * @export
 * @returns {SafePromise}
 */
export function defaultCatchAsWarning(promise) {
    if (window.USE_SAFE_PROMISE) {
        return new SafePromise(promise).defaultCatch(serverCommunicationWarning);
    } else {
        _.delay(()=>promise.catch(serverCommunicationWarning),300);
        return promise;
    }
}

function showError(message) {
    let errorMessage = '<h3>Tut uns leid, aber es ist ein Fehler aufgetreten. <br/> Sie müssen die Seite neu laden </h3> <br/> <span style="font-weight:normal;font-size:small;"> Details: %s </span>';
    try {
        errorMessage = I18N('ErrorOccuredWithMessage', message);
    } catch (e) {
    }
    dialogs.showError(errorMessage);
}

function showWarning(message) {
    let warningMessage = '<h3>Tut uns leid, aber es ist ein Fehler aufgetreten</h3> <br/> <span style="font-weight:normal;font-size:small;"> Details: %s </span>';
    try {
        warningMessage = I18N('WarningOccuredWithMessage',message);
    } catch (e) {
    }
    dialogs.showWarning(warningMessage);
}

window.WAS_UNRECOVERABLE_ERROR = false;

let CUSTOM_ERROR_HANDLERS = [];

// ermöglicht es, auf jeden beliebigen nicht-abgefangenen Fehler für eine bestimmte Zeitspanne zu reagieren
function registerCustomErrorHandler(validForMs,callback) {
    // remove timedout handlers => vermeidet Memory-Leaks
    const now = new Date().getTime();
    CUSTOM_ERROR_HANDLERS = _.filter(CUSTOM_ERROR_HANDLERS,function(handler){
        return now<handler.validUntil;
    });
    // neu hinzufügen
    CUSTOM_ERROR_HANDLERS.push({
        validUntil: new Date(Date.now() + validForMs),
        callback: callback
    });
}

(function() {
	const oldErrorHandler = window.onerror;
	let countErrorRecursiveCalls = 0;
	let overwriteGlobalOnError = true;

    if (typeof SETTINGS !== 'undefined' && typeof SETTINGS.overwriteGlobalErrorHandler !== 'undefined' && !SETTINGS.overwriteGlobalErrorHandler) {
        overwriteGlobalOnError = false;
    }

	if (overwriteGlobalOnError) {
        window.onerror = errorHandler;
    }

	function errorHandler(message, javascriptSourceFileUrl, lineNumber, columnNumber, errorObject) {
		if (countErrorRecursiveCalls>0) {
			return;
		}
		countErrorRecursiveCalls++;

		window.WAS_UNRECOVERABLE_ERROR = true;
		if (oldErrorHandler) {
			try {
				oldErrorHandler(message, javascriptSourceFileUrl, lineNumber, columnNumber, errorObject);
			} finally {
			}
		} else {
			console.log(message,' (in '+javascriptSourceFileUrl+' line '+lineNumber+')', errorObject);
		}
        showError(message);
        try {
            const now = Date.now();
            _.each(CUSTOM_ERROR_HANDLERS,function(handler){
                if (now<handler.validUntil) {
                    handler.callback(message, javascriptSourceFileUrl, lineNumber);
                }
            });
            CUSTOM_ERROR_HANDLERS = [];
        } catch (e) {
            console.log('error in onerror during CUSTOM_ERROR_HANDLERS',e);
        }
		return false;
	}

})();

